export type ContactClickType = 'phone' | 'whatsapp';

function contactClickTypeFromHref(href: string): ContactClickType | null {
    const normalized = href.toLowerCase();
    if (normalized.indexOf('tel:') === 0) return 'phone';
    if (normalized.indexOf('whatsapp') >= 0 || normalized.indexOf('wa.me') >= 0) return 'whatsapp';
    return null;
}

function contactTrackingEndpoint(): string {
    const apiHost = process.env.REACT_APP_HOST_NAME || '';
    return `${apiHost}/contact-clicks`;
}

export function trackContactClick(type: ContactClickType): void {
    if (typeof window === 'undefined') return;

    const payload = new URLSearchParams();
    payload.set('type', type);
    payload.set('page_path', window.location.pathname);
    const body = payload.toString();
    const endpoint = contactTrackingEndpoint();

    if (navigator.sendBeacon) {
        const queued = navigator.sendBeacon(
            endpoint,
            new Blob([body], { type: 'application/x-www-form-urlencoded;charset=UTF-8' })
        );
        if (queued) return;
    }

    void fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body,
        keepalive: true,
        mode: 'cors'
    }).catch(() => undefined);
}

export function installContactClickTracking(): () => void {
    const handleClick = (event: MouseEvent): void => {
        const target = event.target as HTMLElement | null;
        const link = target && target.closest ? target.closest('a') : null;
        if (!link) return;
        const type = contactClickTypeFromHref(link.getAttribute('href') || '');
        if (type) trackContactClick(type);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
}
